export const CONSUMPTION = "v2/users/consumption";
export const SEND_TOKEN = "v2/webhook/api-token";
export const WEBHOOK_URL = "v2/webhook";
export const WEBHOOK_NOTIFICATIONS = "v2/webhook/notifications";